export default __webpack_public_path__ + "static/media/choose-bg.96e8302f.jpg";